import axios from 'axios';
import { User, GuestPasscode } from '../types';

const api = axios.create({
  baseURL: '/api/v2/guest',
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

export const verifyPasscode = (code: string) =>
  api.post<{ user: User; pages: { slug: string; title: string }[]; page_scoped: boolean }>('/verify', { code }).then(r => r.data);

export const guestLogout = () =>
  api.post('/logout').then(r => r.data);

export const listPasscodes = () =>
  api.get<{ passcodes: GuestPasscode[] }>('/passcodes').then(r => r.data);

export const createPasscode = (data: { label: string; expiry: string }) =>
  api.post<{ passcode: GuestPasscode }>('/passcodes', data).then(r => r.data);

export const revokePasscode = (id: number) =>
  api.delete(`/passcodes/${id}`).then(r => r.data);
